/**
 * Bench Sales Dashboard — static layout seed data.
 *
 * Live widgets (fetched in bench-sales-dashboard.component.ts):
 *   - Weekly Activity Metrics   -> /dashboard/bench-sales/weekly-activity-metrics
 *   - Offer Pipeline Tracker    -> /dashboard/bench/offer-pipeline
 *   - Recent Submissions        -> /dashboard/recentSubmissions
 *   - Submission Pipeline funnel + Bench Candidates & Submissions (MTD) KPIs
 *                               -> candidates/getBusinessCandidatePipelineStats
 *   - Today's Activity          -> candidates/getBusinessTodaysActivity
 *
 * Other widgets have no backend API yet. Their mock arrays here are left
 * intentionally empty / zeroed so the card chrome still renders but shows
 * no data — a visible signal to the backend team that these widgets are
 * awaiting their APIs.
 *
 * `insights` (AI Insight strip) retains seed copy per product decision.
 */
export const BENCH_MOCK = {
  insights: [
    {
      tone: 'amber', tag: 'Expiring',
      body: '<strong>Alex Singh\'s</strong> bench availability expires in <strong>3 days</strong> with no active submissions. Sumo AI found 4 matching open roles — submit now to avoid losing placement window.',
      cta: 'View matches →'
    },
    {
      tone: 'green', tag: 'Momentum',
      body: 'Your placement rate is up <strong>40%</strong> vs last month. TechNova and Roundclouds are your top converting clients — <strong>3 more open roles</strong> with them this week.',
      cta: 'View opportunities →'
    },
    {
      tone: 'blue', tag: 'Discovery',
      body: '<strong>7 new AWS/DevOps roles</strong> posted in the last 24 hours matching your bench. <strong>Joel Miller</strong> (rejected by Brenlova) fits 3 of them at 80%+ match.',
      cta: 'Review now →'
    }
  ],

  // KPI stat cards. Bench Candidates + Submissions (MTD) values are overridden
  // live by `kpiOverrides` in the component; the other two await their own API.
  kpis: [
    { accent: 'purple', iconName: 'tablerUser',     label: 'Bench Candidates',   value: '0', sub: '',             trend: { dir: 'flat', text: '' } },
    { accent: 'blue',   iconName: 'tablerSend',     label: 'Submissions (MTD)',  value: '0', sub: '',             trend: { dir: 'flat', text: '' } },
    { accent: 'amber',  iconName: 'tablerCalendar', label: 'Interviews (MTD)',   value: '0', sub: '', trend: { dir: 'flat', text: '' } },
    { accent: 'green',  iconName: 'tablerCheck',    label: 'Placements (MTD)',   value: '0', sub: '', trend: { dir: 'flat', text: '' } }
  ],

  // ── Awaiting backend APIs (cards render empty) ──────────────────────
  activeCandidates: [],
  topJobs: [],
  sumoRec: {
    body: '<strong>Joe Smith</strong> is a strong match (94%) for the Java Full Stack Developer role at Roundclouds closing in <strong>2 days</strong>. Submit now before the deadline — Sumo AI predicts a 3× higher interview rate for same-day submissions on closing roles.'
  },
  interviewsToday: [],

  // Today's Activity is already backed by a live API (super-admin only);
  // this empty fallback is used until the first response arrives OR when
  // the user isn't a super-admin.
  todayActivity: [],
  todayActivityCount: 0,

  needsAttention: [],

  // Submission Pipeline funnel + rates: live (candidates/getBusinessCandidatePipelineStats).
  // Empty fallbacks — template uses `(submissionFunnelRows || data.submissionFunnel)` etc.
  submissionFunnel: [],
  funnelRates: [],

};
